import { Link } from "react-router-dom";

export const Footer = () => (
  <footer
    data-testid="site-footer"
    className="border-t border-terradark/30 bg-terra text-cream"
  >
    <div className="mx-auto flex max-w-7xl flex-col items-start justify-between gap-8 px-4 py-12 sm:px-6 md:flex-row md:items-center lg:px-8">
      <div className="flex items-center gap-2.5">
        <img src="/assets/icon-transparent.png" alt="Moove icon" className="h-8 w-auto" />
        <div>
          <p className="font-poppins text-base font-semibold text-cream">Moove</p>
          <p className="text-xs text-cream/70">Walk to wake up.</p>
        </div>
      </div>

      <div className="flex flex-wrap items-center gap-6 text-sm">
        <Link to="/privacy" data-testid="footer-privacy-link" className="text-cream/80 transition-colors hover:text-cream">
          Privacy
        </Link>
        <Link to="/contact" data-testid="footer-contact-link" className="text-cream/80 transition-colors hover:text-cream">
          Contact
        </Link>
        <a
          href="mailto:humans@onedaybuild.co"
          data-testid="footer-email-link"
          className="text-cream/80 transition-colors hover:text-cream"
        >
          humans@onedaybuild.co
        </a>
      </div>

      <p className="text-xs text-cream/60">© 2026 Moove. A One Day Build.</p>
    </div>
  </footer>
);
